import { render, staticRenderFns } from "./NaviMenu.vue?vue&type=template&id=2c43184e&"
import script from "./NaviMenu.vue?vue&type=script&lang=ts&"
export * from "./NaviMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports